/**
 * useTypeCounts — 워크스페이스 업무유형별 아이템 건수(사이드바 메뉴 배지). GET /api/items/type-counts.
 *
 * 업무유형 목록(useWorkitemTypes)에서 분리한 건수 전용 조회. 키가 items.all 아래라 아이템을 바꾸는
 * 뮤테이션(등록·삭제·연계생성·전이 등)이 items.all 을 무효화하면 함께 다시 받음.
 * 응답: { "wt-capa": 11, "wt-ncr": 9, ... } (type_id → 건수).
 */
import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export function useTypeCounts(workspaceSlug: string | undefined) {
  return useQuery({
    queryKey: queryKeys.items.typeCounts(workspaceSlug ?? ""),
    queryFn: () => apiFetch<Record<string, number>>("/api/items/type-counts", { workspaceSlug }),
    enabled: Boolean(workspaceSlug),
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
